import React, { useState, useRef, lazy } from 'react';
import { ChevronLeftIcon, ChevronRightIcon, ImagesIcon } from 'lucide-react';
type CarouselImage = {
  src: string;
  alt: string;
};
const slides: CarouselImage[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/mLWd2pCR8RheRPjHUSwhHU/IMG_5297.jpg',
  alt: 'Página del Kit Yoga360 sobre niveles de movilidad'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/ohEkWQeXL5HgAU4ZAWDeur/IMG_5298.jpg',
  alt: 'Página del Kit Yoga360 sobre respiración consciente sentada'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/3qdBQj5qbRzkjJxVg7eC7a/IMG_5299.jpg',
  alt: 'Página del Kit Yoga360 sobre resultados de autoevaluación de insomnio'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/jHzMbNhE5uiechkhDGnND8/IMG_5300.jpg',
  alt: 'Página del Kit Yoga360 sobre la postura del niño'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/c4X2MrwKYhPdBqormLxJFf/IMG_5301.jpg',
  alt: 'Página del Kit Yoga360 sobre los efectos de ocho horas sentado'
}];
export function InstagramCarousel() {
  const viewportRef = useRef<HTMLDivElement>(null);
  const [activeSlide, setActiveSlide] = useState(0);
  function goToSlide(index: number) {
    const viewport = viewportRef.current;
    if (!viewport) return;
    const nextIndex = (index + slides.length) % slides.length;
    viewport.scrollTo({
      left: viewport.clientWidth * nextIndex,
      behavior: 'smooth'
    });
    setActiveSlide(nextIndex);
  }
  function handleScroll() {
    const viewport = viewportRef.current;
    if (!viewport) return;
    const slideIndex = Math.round(viewport.scrollLeft / viewport.clientWidth);
    setActiveSlide(Math.min(Math.max(slideIndex, 0), slides.length - 1));
  }
  return <section aria-labelledby="contenido-kit" className="bg-[#fffaf1] px-5 py-12" data-id="element-19">
      <div className="mx-auto max-w-xl" data-id="element-20">
        <div className="text-center" data-id="element-21">
          <p className="flex items-center justify-center gap-2 text-xs font-bold uppercase tracking-[0.14em] text-[#b85f42]" data-id="element-22">
            <ImagesIcon className="h-4 w-4" aria-hidden="true" data-id="element-23" />
            Mirá el contenido
          </p>
          <h2 id="contenido-kit" className="mt-2 font-serif text-3xl leading-tight" data-id="element-24">
            Así se ve el Kit por dentro
          </h2>
          <p className="mt-3 text-sm leading-6 text-[#566056]" data-id="element-25">
            Deslizá para conocer algunas páginas del programa y sus bonos.
          </p>
        </div>

        <div className="relative mt-7" data-id="element-26">
          <div ref={viewportRef} onScroll={handleScroll} className="flex snap-x snap-mandatory overflow-x-auto rounded-2xl border border-[#d9d2c4] bg-[#eee8dc] shadow-md [scrollbar-width:none] [&::-webkit-scrollbar]:hidden" aria-label="Carrusel de páginas del Kit Yoga360" data-id="element-27">
            {slides.map((slide, index) => <figure key={slide.src} className="w-full shrink-0 snap-center" data-id="element-28">
                <img src={slide.src} alt={slide.alt} className="aspect-[0.72] w-full object-cover" loading={index === 0 ? 'eager' : 'lazy'} data-id="element-29" />
              </figure>)}
          </div>

          <button type="button" onClick={() => goToSlide(activeSlide - 1)} className="absolute left-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-[#fffdf8]/95 text-[#263a2a] shadow-md transition hover:bg-white focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/35" aria-label="Ver imagen anterior" data-id="element-30">
            <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-31" />
          </button>
          <button type="button" onClick={() => goToSlide(activeSlide + 1)} className="absolute right-3 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-[#fffdf8]/95 text-[#263a2a] shadow-md transition hover:bg-white focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/35" aria-label="Ver imagen siguiente" data-id="element-32">
            <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-33" />
          </button>
        </div>

        <div className="mt-4 flex items-center justify-center gap-2" aria-label={`Imagen ${activeSlide + 1} de ${slides.length}`} data-id="element-34">
          {slides.map((slide, index) => <button key={slide.src} type="button" onClick={() => goToSlide(index)} className={`h-2 rounded-full transition-all focus:outline-none focus-visible:ring-4 focus-visible:ring-[#b85f42]/35 ${index === activeSlide ? 'w-6 bg-[#b85f42]' : 'w-2 bg-[#c9bcae]'}`} aria-label={`Ir a la imagen ${index + 1}`} aria-current={index === activeSlide ? 'true' : undefined} data-id="element-35" />)}
        </div>
      </div>
    </section>;
}